/* Card.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDyzSk%7Bborder-radius%3Avar(--ds-radius-xlarge%2C9pt)%7D%0A._23rrnHcvle%7Btransition%3Abackground-color%20.2s%20ease-in-out%2Cbox-shadow%20.2s%20ease-in-out%2Ctransform%20.2s%20ease-in-out%7D%0A._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._0KLXrulfZc%7Bbackground-color%3Avar(--ds-surface%2C%23fff)%7D%0A._0jFU0VN91d%7Bheight%3A100%25%7D%0A._3B9ZVQJNoT%3Ahas(%5Bdata-card-pressable%5D%3Aactive)%7Bbackground-color%3Avar(--ds-surface-pressed%2C%23dddee1)%7D%0A._2bmPrZzwhj%3Ahas(%5Bdata-card-pressable%5D%3Aactive)%7Bbox-shadow%3Avar(--ds-shadow-raised%2C0%201px%201px%20%231e1f2140%2C0%200%201px%20%231e1f214f)%7D%0A._1eOmH6d1Zr%3Ahover%7Bbackground-color%3Avar(--ds-surface-hovered%2C%23f0f1f2)%7D%0A._3fSdSTGk8v%3Ahover%7Bbox-shadow%3Avar(--ds-shadow-overlay%2C0%208px%209pt%20%231e1f2126%2C0%200%201px%20%231e1f214f)%7D%0A._3NJLv8TCo3%3Ahover%7Btransform%3AtranslateY(-1px)%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._2V7sgONvrM%7Bborder-width%3Avar(--ds-border-width%2C1px)%7D%0A._3hxITi6wH8%7Bborder-style%3Asolid%7D%0A._3vBAKH9r67%7Bborder-color%3Avar(--ds-border%2C%230b120e24)%7D%0A._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D%0A._1mT5xdWVPG%7Bposition%3Aabsolute%7D%0A._2I62gzPgdg%7Binset-block-start%3Avar(--ds-space-0%2C0)%7D%0A._1ZB6UyPgdg%7Binset-block-end%3Avar(--ds-space-0%2C0)%7D%0A._3iC0zdPgdg%7Binset-inline-start%3Avar(--ds-space-0%2C0)%7D%0A._1OKFqYPgdg%7Binset-inline-end%3Avar(--ds-space-0%2C0)%7D%0A._42Yu6BgtVO%7Bz-index%3A100%7D%0A._0KLXrujOvk%7Bbackground-color%3Atransparent%7D%0A._39xV02N91d%7Bwidth%3A100%25%7D%0A._3iDTPbgBM8%7Bdisplay%3Agrid%7D%0A._2iEGP2IZbP%7Bgrid-template-columns%3Aauto%7D%0A._0ca6V72ulg%7Bgrid-template-rows%3Aauto%20auto%201fr%20auto%7D%0A._3NN0tOmM0j%7Bgrid-template-areas%3A%22cover%22%20%22content%22%20%22metadata%22%20%22footer%22%7D%0A._42d1HA8HPE%7Brow-gap%3Avar(--ds-space-150%2C9pt)%7D");




























import React, { useCallback } from 'react';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Pressable } from '@atlaskit/primitives/compiled/pressable';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import type { CardProps } from '../../../types';
const styles = {
  card: "_0bjKvDyzSk _23rrnHcvle _1mT5xdRAKS _0KLXrulfZc _0jFU0VN91d",
  interactive: "_3B9ZVQJNoT _2bmPrZzwhj _1eOmH6d1Zr _3fSdSTGk8v _3NJLv8TCo3",
  surface: "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _24h04i2Njc _0jFU0VN91d",
  pressable: "_0bjKvDyzSk _1mT5xdWVPG _2I62gzPgdg _1ZB6UyPgdg _3iC0zdPgdg _1OKFqYPgdg _42Yu6BgtVO _0KLXrujOvk",
  content: "_1mT5xdRAKS _0jFU0VN91d _39xV02N91d _3iDTPbgBM8 _2iEGP2IZbP _0ca6V72ulg _3NN0tOmM0j _42d1HA8HPE"
};
export const Card = ({
  children,
  ariaLabel,
  onClick,
  isDisabled = false,
  testId,
  xcss,
  ...boxProps
}: CardProps): React.JSX.Element => {
  const handleClick = useCallback(() => {
    onClick?.();
  }, [onClick]);
  return <Box {...boxProps} xcss={cx(styles.card, Boolean(onClick) && !isDisabled && styles.interactive, xcss)} testId={testId}>
			{onClick ? <Pressable xcss={styles.pressable} onClick={handleClick} aria-label={ariaLabel} isDisabled={isDisabled} data-card-pressable /> : null}
			<Box xcss={styles.surface}>
				<Stack xcss={styles.content} space="space.200">
					{children}
				</Stack>
			</Box>
		</Box>;
};